export default "__VITE_ASSET__B8iKiJk8__"